package com.neurobs.ccabserver.subjectsessionview

import com.neurobs.ccab.{SubjectSessionsRequestData, IdentityData}
import com.neurobs.ccabserver.subjectsessionview.components.analysisview.AnalysisView
import com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.SessionRunView
import com.neurobs.ccabserver.subjectsessionview.components.sessionselection.SessionSelection
import com.neurobs.ccabserver.subjectsessionview.components.sessionview.{SessionInfo, SessionTable, SubjectInfo}
import com.neurobs.ccabserver.subjectsessionview.states.{RunSelectionStateProvider, SessionSelectionState, SessionSelectionStateProvider, TestAnalysisStateProvider, UserState}
import com.neurobs.react.ReactElementFactory
import com.neurobs.react.semanticui.{UiContainerFactory, UiDividerFactory, UiGridFactory, UiHeaderFactory}
import com.neurobs.util.Guid
import org.scalajs.dom
import org.scalajs.dom.raw.Element
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.ReactDOM

import scala.scalajs.js

class Main(targetDiv: Element, requestData: SubjectSessionsRequestData, userData: IdentityData, openSessionLogPanel: (Guid, Long) => Unit, defaultSessionId: Option[Long], defaultTestRunId: Option[Long]) {

  ReactDOM.render(
    SubjectSessionView(requestData, userData, openSessionLogPanel, defaultSessionId = defaultSessionId, defaultTestRunId = defaultTestRunId),
	  targetDiv
  )
}

@react
object SubjectSessionView {
  case class Props(requestData: SubjectSessionsRequestData, userData: IdentityData, openSessionLogPanel: (Guid, Long) => Unit, defaultSessionId: Option[Long], defaultTestRunId: Option[Long])
  val component = FunctionalComponent[Props] { props =>

    val appHtml = UiGridFactory.Grid(
      UiGridFactory.GridColumn(
        SubjectInfo(
          UiContainerFactory.Segment(_)("raised blue")
        ),
        SessionSelection(
          ReactElementFactory.Div(_)
        )
      )("four wide center aligned"),
      UiGridFactory.GridColumn(
        SessionInfo(
          UiContainerFactory.Segment(_)("raised blue")
        ),
        SessionTable()
      )("six wide center aligned"),
      UiGridFactory.GridColumn(
        SessionRunView()
        //AnalysisView()
      )("six wide center aligned")
    )

	  UserState.provider(UserState(props.userData))(
      SessionSelectionStateProvider(props.requestData, props.openSessionLogPanel, props.defaultSessionId, props.defaultTestRunId)(
        RunSelectionStateProvider(
          TestAnalysisStateProvider(
            appHtml
          )
        )
      )
    )
  }
}